// @flow
import React from "react";
import { Card, Button } from "tabler-react";
import C3Chart from "react-c3js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import clientService from "../../services/client"; 

class FeedbackAnalytic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), 
      endDate: new Date(),
      
      // Structure for Call Feedback
      callData: {
        sent: 0,
        responseCount: 0,
        responseRate: '0%',
        chart: { 
          columns: [], 
          type: 'pie', 
          colors: { 'Good': '#28a745', 'Neutral': '#ffc107', 'Bad': '#dc3545' }
        }
      },
      
      // Structure for Report Feedback
      reportData: {
        sent: 0,
        responseCount: 0,
        responseRate: '0%',
        chart: { 
          columns: [], 
          type: 'pie', 
          colors: { 'Good': '#28a745', 'Neutral': '#ffc107', 'Bad': '#dc3545' }
        }
      }
    };
  }

  componentDidMount() {
    this.fetchFeedbackData();
  }

  handleDateChange(type, date) {
    this.setState({ [type]: date });
  }

  async fetchFeedbackData() {
    const { startDate, endDate } = this.state;

    // Helper to format date as YYYY-MM-DD regardless of time, fixing timezone offset issues
    const formatDate = (date) => {
        if (!date) return '';
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    try {
      const res = await clientService.getFeedbackStats(
            formatDate(startDate), 
            formatDate(endDate)
        );
      
      if (res && res.data) {
        const call = res.data.callFeedback;
        const report = res.data.reportFeedback;

        this.setState({
          callData: {
            sent: call.sent,
            responseCount: call.responseCount,
            responseRate: call.responseRate,
            chart: { ...this.state.callData.chart, columns: call.chartData }
          },
          reportData: {
            sent: report.sent,
            responseCount: report.responseCount,
            responseRate: report.responseRate,
            chart: { ...this.state.reportData.chart, columns: report.chartData }
          }
        });
      }
    } catch (err) {
      console.error("Error fetching feedback stats", err);
      // Optional: Reset stats on error
    }
  }

  render() {
    // Pie Chart Configuration
    const pieConfig = {
      label: {
        ratio: 0.8,
        format: function (value, ratio, id) {
          return `${value} (${(ratio * 100).toFixed(1)}%)`;
        }
      }
    };

    // Reusable Component for the Stats Card
    const renderStatsBox = (title, data) => (
      <div className="col-md-6">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">{title}</h4>
          </div>
          <div className="card-body">
            {/* Funnel Metrics Row */}
            <div className="row text-center mb-4" style={{borderBottom: '1px solid #eee', paddingBottom: '15px'}}>
              <div className="col-4">
                <div className="h2 m-0 font-weight-bold">{data.sent}</div>
                <div className="text-muted small">Sent (Excluding Enqueued)</div>
              </div>
              <div className="col-4">
                <div className="h2 m-0 font-weight-bold">{data.responseCount}</div>
                <div className="text-muted small">Responses</div>
              </div>
              <div className="col-4">
                <div className="h2 m-0 font-weight-bold text-blue">{data.responseRate}</div>
                <div className="text-muted small">Rate</div>
              </div>
            </div>

            {/* Pie Chart */}
            <C3Chart
              data={data.chart}
              pie={pieConfig}
              size={{ height: 250 }}
              legend={{ show: true, position: 'bottom' }}
              tooltip={{ show: true }}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className="col col-12">
        <div className="card card101">
          {/* Top Bar: Title & Date Picker */}
          <div className="row p-3 align-items-center">
            <div className="col-md-5">
              <h3 className="card-title mb-0">Feedback Analytics</h3>
            </div>
            <div className="col-md-7">
              <div className="row">
                <div className="col-5">
                  <DatePicker 
                    className="form-control"
                    selected={this.state.startDate}
                    onChange={(date) => this.handleDateChange('startDate', date)}
                    maxDate={this.state.endDate}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Start Date"
                  />
                </div>
                <div className="col-5">
                  <DatePicker 
                    className="form-control"
                    selected={this.state.endDate}
                    onChange={(date) => this.handleDateChange('endDate', date)}
                    minDate={this.state.startDate}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="End Date"
                  />
                </div>
                <div className="col-2">
                  <Button color="primary" onClick={() => this.fetchFeedbackData()}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="card-body bg-light">
            <div className="row">
              {renderStatsBox("Call Feedback", this.state.callData)}
              {renderStatsBox("Overall Feedback", this.state.reportData)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FeedbackAnalytic;